import { FormLayout } from '@customerio/pluma-components/react';
import {
  BucketNameAndPathFields,
  bucketPreviewPath,
  ConfigTextField,
  RegionSelect,
  TooltipLink,
  UploadPathPreview,
} from './fields';
import { YANDEX_REGION_OPTIONS } from './regions';
import type { ProviderFormProps } from './types';

function consoleUrl(path: string): string {
  return `https://storage.yandexcloud.net/${path}`;
}

/**
 * Bucket, credentials and region for a Yandex Cloud sync. Same field set as S3 —
 * Yandex Object Storage speaks the S3 API — minus the credentials hint, which has
 * no Yandex equivalent to point at.
 */
export function YandexForm(props: ProviderFormProps) {
  const path = bucketPreviewPath(props.config);

  return (
    <FormLayout>
      <BucketNameAndPathFields form={props} />

      <UploadPathPreview
        scheme="yandex"
        path={path}
        tooltip={
          <>
            View files in your Yandex console: <TooltipLink href={consoleUrl(path)}>{consoleUrl(path)}</TooltipLink>.
          </>
        }
      />

      <ConfigTextField form={props} field="access_key" label="Access key" isSecret autofocus={false} />

      <ConfigTextField form={props} field="secret_key" label="Secret key" isSecret autofocus={false} />

      <RegionSelect form={props} label="Region" options={YANDEX_REGION_OPTIONS} />
    </FormLayout>
  );
}
